
import { Container } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import {
  generateRandomToken,
  getLocalStorageMenuItem,
  setLocalStorageMenuItem,
  setMobileBackColor,
  setMobileSettings,
} from "../utility";
import axios from "axios";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import coverSample from "../images/No_Image_Available.jpg";
import "../css/mobileScreens.css";
import DishFullRow from "../components/mobile screen/sections/dishFullRow";
import Toast from "../common/toast";
import i18next, { t } from "i18next";
import { Popper } from "@mui/material";
import TopMain from "../components/mobile screen/sections/TopMain";
import Loading from "../common/loading";
import LoadingTreeDataDialog from '../components/mobile screen/mobileComponents/LoadingTreeDataDialog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BottomNavBar from "../components/BottomNavBar";
import Top from "../components/mobile screen/sections/Top";
const LabelsScreen = ({ tableQr, tableName }) => {
  const [loadingTree, setLoadingTree] = useState(false);
  const [loading, setLoading] = useState(true);

  const [params, setParams] = useSearchParams();
  const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || [])
  const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [labelItems, setLabelItems] = useState(getLocalStorageMenuItem("tree_data")?.labels?.filter(label => label.name === params.get("label_name")) || [])

  const [searchParams] = useSearchParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  // Add this useEffect for responsive detection
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setLabelItems(getLocalStorageMenuItem("tree_data")?.labels?.filter(label => label.name === params.get("label_name")) || [])
  }, [searchParams]);

  const loadTree = async () => {
    setLoadingTree(true);
    try {
      const timeZone = getLocalStorageMenuItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${tableQr}/public-tree?table=${params.get('t') || null}`,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang") || "",
            timeZone: timeZone.replace(/["]+/g, ''),
          },
        }
      );
      if (promise?.data?.data?.length === 0 || !promise?.data?.data?.details || !promise?.data?.data?.tree || !promise?.data?.data?.items) {
        setLoadingTreeDialog(true);
      }
      setAllTreeData(promise?.data?.data || [])
      setLabelItems(promise?.data?.data?.lables?.filter(label => label.name === params.get("label_name")))
      setLocalStorageMenuItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      setMobileSettings(promise?.data?.data?.details)
      return promise?.data?.data;
    } catch (error) {
      // Handle error
    } finally {
      setLoadingTree(false);
    }
  }

  const loadTreeData = async () => {
    if (allTreeData.length === 0 || !allTreeData.details || !allTreeData.tree || !allTreeData.items) {
      loadTree();
    } else {
      const pathname = location.pathname;
      const pathSegments = pathname.split('/');
      const menu_code_number = pathSegments[2];
      const treeMenu_code_number = allTreeData?.details?.code_number;
      if (menu_code_number !== treeMenu_code_number) {
        loadTree();
      }
    }

  };
  const { qrName, qrCode } = useParams();
  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(null);
  const [sectionNumber, setSectionNumber] = useState(params.get("section"));

  const [favorites, setFavorites] = useState([]);
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  const [currentSectionId, setCurrentSectionId] = useState(0);
  const sectionRefs = useRef([]);

  var lang = getLocalStorageMenuItem("lang");

  useEffect(() => {
    const initializeLanguage = async () => {
      lang = getLocalStorageMenuItem("lang");

      if (!lang) {
        lang = params.get("lang");
        if (lang) {
          setLocalStorageMenuItem("lang", lang);
        } else {
          lang = 'en';
        }
      }

      // Set the language in i18next
      await i18next.changeLanguage(lang);

      // Set loading to false after language change
      setLoading(false);
    };

    initializeLanguage();
  }, [params, searchParams]);



  useEffect(() => {
    loadTreeData();

  }, []);

  const updateTreeData = (newTreeData) => {
    setAllTreeData(newTreeData)
  }

  const handleSectionClick = (index) => {
    const section = sectionRefs.current[index];
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 140,
        behavior: "smooth",
      });
    }
    setCurrentSectionId(index);
  };




  const handleLanguage = async (lang) => {
    i18next.changeLanguage(lang);
    document.querySelector("html").lang = lang;
    setLocalStorageMenuItem("lang", lang);
    params.set("lang", lang);
    if (lang === "ar" || lang === "fa") {
      document.body.classList.remove("latino-font");
      document.body.classList.add("arabic-font");
    } else {
      document.body.classList.add("latino-font");
      document.body.classList.remove("arabic-font");
    }
    setParams(params);
  };





  const backToMain = () => {
    setSectionNumber(0);
    params.set("section", 0);
    setParams(params);
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  const handleFavorite = (item) => {

    const index = favorites.findIndex((fav) => fav.id === item.id);
    if (index === -1) {
      const newFavorites = [...favorites, item];
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Added to favorites"));
    } else {
      const newFavorites = favorites.filter(
        (favItem) => favItem.id !== item.id
      );
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Removed from favorites"));
    }
  };

  const { data: favoritesData, isLoading: favoritesIsLoading } = useQuery(
    "favorites",
    async () => {
      const favoritesFromCookie = getLocalStorageMenuItem("favorites");
      if (favoritesFromCookie) {
        const favoritesItems = favoritesFromCookie;
        const favoritesArray = favoritesItems?.map((item) => item.id);
        const promise = await axios.get(
          `${process.env.REACT_APP_API
          }/menus/${qrCode}/favourites?items=${JSON.stringify(favoritesArray)}`,
          { headers: { localization: lang } }
        );
        setFavorites(favoritesFromCookie);
        return promise;
      }
      setFavorites([]);
      return [];
    }
  );




  useEffect(() => {
    if (divRef.current) {
      const width = divRef.current.offsetWidth;
      setDivWidth(width);
    }
  });

  const handleOpenToast = (message) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = true;
    toast.message = message;
    setToastSettings(toast);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setToastSettings({ open: false, message: "", success: false });
  };

  useEffect(() => {

    if (!getLocalStorageMenuItem("gustToken")) {
      setLocalStorageMenuItem("gustToken", generateRandomToken(25));
    }

    document.body.style.direction = "ltr";
  }, []);

  function CustomPopper(props) {
    return <Popper {...props} placement="top-start" disablePortal={true} />;
  }

  if (loading || loadingTree) {
    return <Loading backColor={setMobileBackColor()} />; // Can show a loader here
  }

  return (
    <div
      key={location.search}
      className={`min-vh-100`}
      style={{ backgroundColor: setMobileBackColor(), marginBottom: "5px" }}
    >
      <ToastContainer />
      <Container >
        <div className="row">
          <div className={`${isDesktop ? '' : 'col-lg-4'} p-0 m-0 ms-auto`} >
            <div
              className="mobile-side-screen"
              style={{ marginBottom: "60px" }}
              ref={divRef}
            >

              <Top
                order_ability={allTreeData?.details?.order_ability || false}
                currentSectionId={currentSectionId}
                currentId={params.get("section")}
                parentId={allTreeData?.details?.parent_id}
                mianSectionsData={{ sections: allTreeData || [] }}
                qrCode={qrCode}
                qrName={qrName}
                handleLanguage={handleLanguage}
                updateTreeData={(newtree) => updateTreeData(newtree)}

                handleOnClick={(index) => handleSectionClick(index)}
                detailsData={allTreeData?.details}
                lablesData={allTreeData?.labels}

                backToMain={backToMain}
                width={divWidth}
                label_name={params.get("label_name") || null}

              />


              <div className="sections">
                <div className="sections-content">
                  {params.get("label_name") && (
                    <div className="mb-3 alignByLang d-flex justify-content-center flex-wrap">
                      {labelItems[0]?.label_items?.map(
                        (item) =>
                          item.active &&
                          (getLocalStorageMenuItem("showOption") ===
                            "twoItem" ? (
                            <DishFullRow
                              in_root={false}
                              key={item.id}
                              item={item}
                              qrCode={qrCode}
                              qrName={qrName}
                              sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                              handleFavorite={handleFavorite}
                              favorites={favorites}
                              suggested={false}
                              not_menu_availability={!allTreeData?.details?.is_available || !allTreeData?.details || !allTreeData?.tree || !allTreeData?.items}
                            />

                          ) : (
                            <DishFullRow

                              in_root={false}
                              key={item.id}
                              item={item}
                              qrCode={qrCode}
                              qrName={qrName}
                              sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                              handleFavorite={handleFavorite}
                              favorites={favorites}
                              suggested={false}
                              not_menu_availability={!allTreeData?.details?.is_available || !allTreeData?.details || !allTreeData?.tree || !allTreeData?.items}
                            />
                          ))
                      )}
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
        <Toast
          open={toastSettings.open}
          message={toastSettings.message}
          resetToast={handleCloseToast}
          success={toastSettings.success}
        />

        <LoadingTreeDataDialog openTreeDialogFlag={loadingTreeDialog} onClose={() => setLoadingTreeDialog(false)} tableName={tableName} tableQr={tableQr} from_home={false} />
      </Container>
      <BottomNavBar qr={tableQr} qrName={tableName} />

    </div>
  );
};

export default LabelsScreen;
